import * as askaquestionService from './askaquestion.service.js';
import { moduleName as ContextServiceName, default as ContextService } from '../../util/context.service';

export default angular.module('gcs.AskaQuestion', ['rhino.components.session','rhino.components.locale',
  'rhino.components.preferences',
  'rhino.components.user'])
  .factory(askaquestionService.moduleName, askaquestionService.default)
  .factory(ContextServiceName, ContextService)
  .name;
